<div class="report-header" *ngIf="report">
    <div class="rh-left">
        <div class="rh-sub">
            BAER ACCOMPLISHMENT REPORT
        </div>
        <div class="rh-title">
            <h1 class="rh-title-h1">{{report.report_name}}</h1>
        </div>
    </div>
    <div class="rh-right">
        <div class="save-info-div" *ngIf="autosave.saving && nav() == ''">
            <div>
                <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
            </div>
            Saving...
        </div>
        <div class="save-info-div" *ngIf="nav() != ''">
            <div>
                <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
            </div>
            Saving...
        </div>
        <div class="save-info-div" *ngIf="autosave.saved && nav() == ''">
            <fa-icon [icon]="faCheck" class="save-check" aria-label="check"></fa-icon>
            {{ savedText }}
        </div>
        <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent"
            *ngIf="report_page != maxPage+1">Save & Close</button>
        <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent"
            *ngIf="report_page == maxPage+1">Close</button>
    </div>
</div>
<div class="report-main" *ngIf="report">
    <div class="report-nav" *ngIf="report_page != maxPage+1">
        <div class="rnav-header">
            <div>Report Sections</div>
        </div>
        @for (name of pageNames; track name; let page = $index) {
        <div
            [ngClass]="'rnav-item rnav-status-'+(report_page==(page+1) ? (current_status ?? report['page_'+(page+1)+'_status_id']) : report['page_'+(page+1)+'_status_id']) +' rnav-current-'+(report_page==page+1)">
            <button class="anchor-button" (click)="goToPage(page+1)">
                <div>
                    @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 1) ||
                    (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 1)){
                    <mat-icon class="current-page">contrast</mat-icon>
                    }
                    @else {
                    @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 2) ||
                    (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 2)) {
                    <mat-icon>check_circle</mat-icon>
                    }
                    @else {<mat-icon>panorama_fish_eye</mat-icon>}
                    }
                    {{page+1}}. {{name}}
                </div>
            </button>
        </div>
        <div class="sub-menu" *ngIf="page==1">
            @for(treatmentType of treatmentTypes; track treatmentType) {
            <div class="rnav-item">
                <button class="anchor-button" (click)="goToPage(page+1, treatmentType.treatment_type_id)">
                    <div>{{treatmentType.treatment_type}}</div>
                </button>
            </div>
            }
        </div>
        }
    </div>
    <div class="report-right-area">
        <div class="report-area">
            <div class="report-section">
                @switch (report_page) {
                @case (1) {<app-accomplishment-details [report]="report" [reportList]="reportList" [(nav)]="nav"
                    [autosave]="autosave" (status)="statusChange($event)" (loaded)="subLoaded()"
                    *ngIf="reportList"></app-accomplishment-details>}
                @case (2) {<app-accomplishment-treatments [report]="report" [reportList]="reportList" [(nav)]="nav"
                    [autosave]="autosave" (status)="statusChange($event)" (loaded)="subLoaded()"
                    *ngIf="reportList"></app-accomplishment-treatments>}
                @case (3) {<app-accomplishment-additional [report]="report" [reportList]="reportList" [(nav)]="nav"
                    [autosave]="autosave" [currentUser]="currentUser" (status)="statusChange($event)"
                    (loaded)="subLoaded()" *ngIf="reportList"></app-accomplishment-additional>}
                @case (4) {<app-accomplishment-submission [report]="report" [reportList]="reportList" [(nav)]="nav"
                    (loaded)="subLoaded()"></app-accomplishment-submission>}
                @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
                }
            </div>
        </div>
        <div class="report-footer" *ngIf="report_page != (maxPage + 1)" style="z-index: 1000;">
            <div class="rf-left">
                @if (report_page > 1) {
                <button class="nav-btn" (click)="back()"><mat-icon>arrow_back_ios</mat-icon>{{report_page - 1}}.
                    {{pageNames[report_page - 2]}}</button>
                }
            </div>
            <div class="rf-right">
                @if (report_page == maxPage) {
                <button class="submit-btn" (click)="forward()" color="accent" [disabled]="!complete">
                    <span>Submit Report</span><mat-icon>arrow_forward_ios</mat-icon></button>
                } @else {
                <button class="nav-btn" (click)="forward()">{{report_page + 1}}.
                    {{pageNames[report_page]}}<mat-icon>arrow_forward_ios</mat-icon></button>
                }
            </div>
        </div>
    </div>
</div>